/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReImportType } from './ReImportType';
import {
    ReImportTypeFromJSON,
    ReImportTypeFromJSONTyped,
    ReImportTypeToJSON,
    ReImportTypeToJSONTyped,
} from './ReImportType';

/**
 * 
 * @export
 * @interface DeleteReImportRequest
 */
export interface DeleteReImportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteReImportRequest
     */
    generatorKeys: Array<string>;
    /**
     * 
     * @type {ReImportType}
     * @memberof DeleteReImportRequest
     */
    type: ReImportType;
}



/**
 * Check if a given object implements the DeleteReImportRequest interface.
 */
export function instanceOfDeleteReImportRequest(value: object): value is DeleteReImportRequest {
    if (!('generatorKeys' in value) || value['generatorKeys'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function DeleteReImportRequestFromJSON(json: any): DeleteReImportRequest {
    return DeleteReImportRequestFromJSONTyped(json, false);
}

export function DeleteReImportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteReImportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'generatorKeys': json['generatorKeys'],
        'type': ReImportTypeFromJSON(json['type']),
    };
}

export function DeleteReImportRequestToJSON(json: any): DeleteReImportRequest {
    return DeleteReImportRequestToJSONTyped(json, false);
}

export function DeleteReImportRequestToJSONTyped(value?: DeleteReImportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'generatorKeys': value['generatorKeys'],
        'type': ReImportTypeToJSON(value['type']),
    };
}

